/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { ExtFile } from 'src/app/_model/ext-file';

@Injectable()
export abstract class ExtFilesDaoService implements Resetable {
  public abstract saveExtFiles(extFiles: ExtFile[]): Promise<void>;
  public abstract getExtFiles(): Promise<ExtFile[]>;
  public abstract createExtFile(extFile: ExtFile): Promise<ExtFile>;
  public abstract updateDownloadStatus(extFile: ExtFile): Promise<void>;
  // The draft payload lives on the ActivityConfirmation now, see
  // ActivityConfirmationsDaoService.updateFilledFormData().
  public abstract deleteExtFiles(extFiles: ExtFile[]): Promise<void>;
  public abstract deleteLocalExtFile(extFile: ExtFile): Promise<void>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
